// extracted by mini-css-extract-plugin
export var cardIcon = "_b2-4";
export var checkboxCard = "_b2-0";
export var checkboxCardSelected = "_b2-1";
export var disabled = "_b2-2";
export var outerBorder = "_b2-3";
export var spacerMedium = "_b2-7";
export var spacerSmall = "_b2-6";
export var spacerXsmall = "_b2-5";